// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2SYjV","detailsBorder":"styles_detailsBorder__2MrnZ"};